export const prependUTF8BOM = (body: string): string => {
  return "\ufeff" + body;
};
